/**
 * FIXTURE LIST COMPONENT
 * 
 * Left panel showing fixtures from Step 4 that need product selection
 * Grouped by area with completion status
 */

import React from 'react';
import { FIXTURE_LABELS, getCategoryForFixture } from '../../hooks/useProductCatalog';
import { getAreaType } from '../../constants/areaTypes';

const FixtureList = ({ 
  areas = [], 
  selections = [], 
  activeFixture, 
  onSelectFixture 
}) => {
  // Build list of fixtures needing products
  const fixturesNeedingProducts = [];
  
  areas.forEach(area => {
    const areaConfig = getAreaType(area.type);
    Object.entries(area.fixtures || {}).forEach(([key, fixture]) => {
      if (fixture.condition === 'exists_replace' || fixture.condition === 'add_new') {
        fixturesNeedingProducts.push({
          area_id: area.area_id,
          area_label: area.label,
          area_type: area.type,
          area_icon: areaConfig.icon,
          fixture_key: key,
          fixture_label: FIXTURE_LABELS[key] || key,
          condition: fixture.condition,
          category: getCategoryForFixture(key),
          hasSelection: selections.some(
            s => s.area_id === area.area_id && s.fixture_key === key
          ),
        });
      }
    });
  });

  // Group by area
  const groupedByArea = fixturesNeedingProducts.reduce((acc, fixture) => {
    if (!acc[fixture.area_id]) {
      acc[fixture.area_id] = {
        area_id: fixture.area_id,
        area_label: fixture.area_label,
        area_icon: fixture.area_icon,
        fixtures: [],
      };
    }
    acc[fixture.area_id].fixtures.push(fixture);
    return acc;
  }, {});

  const selectedCount = fixturesNeedingProducts.filter(f => f.hasSelection).length;
  const totalCount = fixturesNeedingProducts.length;

  return (
    <div className="fixtures-panel">
      <h3>Items to Select</h3>
      
      {Object.values(groupedByArea).map(group => (
        <div key={group.area_id} className="fixture-group">
          <div className="area-header">
            <span className="area-icon">{group.area_icon}</span>
            <span>{group.area_label}</span>
          </div>
          
          {group.fixtures.map(fixture => {
            const isActive = activeFixture?.area_id === fixture.area_id && 
                            activeFixture?.fixture_key === fixture.fixture_key;
            
            return (
              <button
                key={`${fixture.area_id}-${fixture.fixture_key}`}
                className={`fixture-item ${isActive ? 'active' : ''} ${fixture.hasSelection ? 'completed' : ''}`}
                onClick={() => onSelectFixture(fixture)}
              >
                <span className="fixture-status">
                  {fixture.hasSelection ? '✓' : '○'}
                </span>
                <span className="fixture-name">{fixture.fixture_label}</span>
                <span className="fixture-condition">
                  {fixture.condition === 'add_new' ? 'New' : 'Replace'}
                </span>
              </button>
            );
          })}
        </div>
      ))}
      
      {totalCount === 0 ? (
        <div className="empty-state">
          <p>No fixtures marked for replacement.</p>
          <p style={{ fontSize: '0.75rem', marginTop: '0.5rem' }}>
            Go back to Step 4 to mark fixtures.
          </p>
        </div>
      ) : (
        <div className="progress-summary">
          {selectedCount} of {totalCount} selected
        </div>
      )}
    </div>
  );
};

export default FixtureList;
